module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_8011.f0c02f7d.png";